"client-only";

import type { FirebaseOptions } from "firebase/app";

const stringifiedFirebaseConfig =
	process.env.NEXT_PUBLIC_FIREBASE_CONFIG ??
	'{"apiKey": "AIzaSyBlWm_v0-slQrOglfRzkpzfexmDwRV4oiU"}';

export const firebaseConfig: FirebaseOptions = JSON.parse(
	stringifiedFirebaseConfig,
) as FirebaseOptions;
